import {ActivityBoxList, ActivityList} from "../components/activityComponent";

export const CryptoActivity = () => {
    return (
        <section className="w-full min-h-[850px]">
            <ActivityBoxList/>
            <ActivityList/>
        </section>
    )
}